import { render, staticRenderFns } from "./Dues.vue?vue&type=template&id=4083650c&"
import script from "./Dues.vue?vue&type=script&lang=js&"
export * from "./Dues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports